import { Pipe, PipeTransform } from '@angular/core';

/**
 * Maps `agreement.status` to a string to present to the user
 */
@Pipe({ name: 'agrStatusMap' })
export class AgreementStatusMapPipe implements PipeTransform {
  private statusMap = {
    // Offers
    requested: 'Agreement Requested',
    initiated: 'pending',
    offer_amended: 'pending',
    offer_declined: 'declined',
    // Agreements (accepted onwards)
    accepted: 'accepted',
    agreement_amended: 'changes pending',
    amendments_accepted: 'accepted',
    amendments_declined: 'accepted',
    terminated: 'terminated',
    agreement_requested: 'Agreement Requested',
    // Urgent action (migration of structured rates)
    urgent: 'Urgent action',
  };

  transform(value: string): string {
    return this.statusMap[value] || 'New';
  }
}
